import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { DropDownMultiCheck } from "../DropDownMultiCheck";

export default function CompetencesAndSkills() {
  const { searchObject, t, setSearchObject } = useAdvanceSearchContext();

  const [technologies, setTechnologies] = useState([]);

  useEffect(() => {
    CommonService.getTechSkills().then((data) => setTechnologies(data));
  }, []);

  function setSelectedSkills(list) {
    setSearchObject({ ...searchObject, skills: list });
  }

  function onChange(e) {
    const { name, checked } = e.target;
    setSearchObject({ ...searchObject, [name]: checked });
  }

  return (
    <>
      <fieldset>
        <legend>{t("Skills")}</legend>
        <div style={{width: "85%"}}>
          <DropDownMultiCheck
            dataList={technologies}
            selecteds={searchObject.skills}
            setSelecteds={setSelectedSkills}
            autoCompleteMode={true}
          />
        </div>
        <div className="col-2" style={{width: "42px", float: "right", marginTop: "-40px"}}>
            <div className="form-group mt-2">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  checked={searchObject.allTechnologies}
                  name="allTechnologies"
                  id="allTechnologies"
                  onChange={onChange}
                />

                <label className="form-label" for="recommended">
                  <span className="recommended-tab-button">{t("All")}</span>
                </label>
              </div>
            </div>
          </div>
      </fieldset>
    </>
  );
}
